import React from 'react';
import { Redirect } from 'react-router-dom';
import { Assessment as AssessmentIcon } from '@mui/icons-material';
import RunListPage from './RunList/RunListPage';
import RunConfigPage from './RunConfig/RunConfigPage';
import RunDetailPage from './RunDetail/RunDetailPage';

export const miniPageRoutes = [
  {
    title: 'AMSO',
    to: '/amso',
    icon: <AssessmentIcon />,
    render: <RunListPage />,
  },
  {
    to: '/amso/new',
    render: <RunConfigPage />,
  },
  {
    to: '/amso/runs/:runId',
    render: <RunDetailPage />,
  },
  {
    to: '/',
    render: <Redirect to="/amso" />,
  },
];

const pageRoutes = miniPageRoutes;

export default pageRoutes;
